// extracted by mini-css-extract-plugin
module.exports = {"container":"FiatRampModal_container__3Dh42","loading":"FiatRampModal_loading__9X4Pu","iframe":"FiatRampModal_iframe__29JZd"};